import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/PoundCircleTwoTone";
import AntdIcon from '../components/AntdIcon';
var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PoundCircleTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PoundCircleTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PoundCircleTwoTone';
}
export default RefIcon;